export default __webpack_public_path__ + "locales/pt-BR/Errors.json?hash=d4d73e7532cdfb7cbb653e45490b255a";